<!-- 底部信息 -->
<template>
  <div class="Home-container">
    <TopBar title="讯天科技" :color="color" :src="logo" v-if="_router" />
    <router-view />
    <div id="bottom">
      <div class="bottom-body">
        <!-- <div class="body-left">
          <div class="left-head">
            <img :src="bgimg" alt="" style="width: 218px; height: 50px" />
          </div>
          <div class="left-bottom">
            Copyright © 2006-2025 ArcherMind Technology 保留所有版权. |
            苏ICP备12345678号-1
          </div>
        </div> -->
        <div class="middle2">
          <div class="middle1-head">
            <strong>快速链接</strong>
          </div>
          <div class="middle1-body">
            <div
              class="body-item"
              style="margin-bottom: 0.75rem; pointer-events: none"
            >
              <span class="" style="color: #3b3b3b">关于我们</span>
            </div>
          </div>
          <div class="middle1-body">
            <div class="body-item">
              <span class="title go" @click="handleclick">诚迈科技</span>
            </div>
          </div>
        </div>
        <div class="middle1">
          <div class="middle1-head">
            <strong>联系我们</strong>
          </div>
          <div class="middle1-body">
            <div class="body-item">
              <span class="title">邮箱:</span>
              <span>marketing@archermind.com</span>
            </div>
            <div class="body-item">
              <span class="title">电话:</span>
              <span>86-25-51887700</span>
              <span class="title">(7*24小时)</span>
            </div>
            <div class="body-item">
              <span class="title">传真:</span>
              <span>86-25-51887711</span>
            </div>
            <div class="body-item">
              <span class="title">地址</span>
              <span>江苏省南京市雨花台区云密城B栋讯天科技</span>
            </div>
          </div>
        </div>
        <div class="body-right"></div>
      </div>
      <div style="font-weight: normal; color: #3b3b3b; text-align: center;margin-bottom: 4px;">
        Copyright © 2006-2025 ArcherMind Technology 保留所有版权. |
        <span @click="handleclick2" style="cursor: pointer">
          苏ICP备2025175631号-1</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import logo1 from '@/assets/projectLogo.png';
import logo2 from '@/assets/projectLogo.png';
import TopBar from '@/components/TopBar.vue';
import bgimg from '@/assets//projectLogo.png';
export default {
  components: { TopBar },
  data() {
    return {
      color: 'rgba(13, 83, 255, 0.12);',
      logo: logo1,
      bgimg,
    };
  },
  computed: {
    _router() {
      if (this.$route.path !== '/supermarket') {
        return true;
      } else {
        return false;
      }
    },
  },
  updated() {
    if (this.$route.path === '/sjfw') {
      this.color = '#000';
      this.logo = logo2;
    } else {
      this.color = '#fff';
      this.logo = logo1;
    }
  },
  created() {
    if (this.$route.path === '/sjfw') {
      this.color = '#000';
      this.logo = logo2;
    }
  },
  methods: {
    setScorll() {
      //    console.log( this.$store.state.scorllTop);

      this.$store.commit('setScorllTop', window.scrollY);
    },
    handleclick() {
      window.open('https://www.archermind.com/', '_blank');
    },
    handleclick2() {
      window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank');
    },
  },
  mounted() {
    // this.$refs.box.addEventListener('scroll',()=>{
    //     console.log(1);

    // })
    window.addEventListener('scroll', this.setScorll);
  },
};
</script>

<style scoped>
.go {
  cursor: pointer;
}
.body-right {
  font-weight: 400;
  font-size: 0.875rem; /* 14px to rem */
  text-align: center;
  line-height: 1.42857; /* 20px to rem */
  letter-spacing: 0.07143rem; /* 1.1px to rem */
  color: #818489;
}
.title {
  font-weight: 400;
  font-size: 0.875rem; /* 14px to rem */
  color: #212224;
  line-height: 1.21429; /* 17px to rem */
  margin-right: 0.32143rem; /* 5px to rem */
}
.Home-container {
  scroll-behavior: smooth;
  width: 100%;
}
#bottom {
  width: 100%;
  height: 250px;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: #f7f7f7;
  color: #3b3b3b;
  z-index: 100;
}
.bottom-body {
  width: 100%;
  display: flex;
  justify-content: center;
  max-width: 1440px;
  margin: 0 auto;
  padding-top: 48px;
}
.QRcode img {
  width: 6.875rem; /* 110px to rem */
  height: 110px;
  margin-bottom: 0.875rem; /* 14px to rem */
  object-fit: cover;
}
.body-left {
  flex: 3;
}
.middle1 {
  width: auto;
}
.middle2 {
  width: 280px;
}
.left-head img {
  width: 20.9375rem; /* 335px to rem */
  height: 56px;
  object-fit: cover;
}
.left-head {
  height: 48px;
  display: flex;
  margin-bottom: 5.96429rem; /* 85px to rem */
}
.left-head p {
  font-family: Regular;
  font-size: 1.5rem; /* 24px to rem */
  height: 48px;
  line-height: 48px;
  font-weight: 500;
  margin-left: 1.14286rem; /* 16px to rem */
}
.icon-github {
  font-size: 2.8125rem; /* 48px to rem */
}
.body-left {
  display: flex;
  flex-direction: column;
}
.left-bottom {
  font-size: 0.8125rem; /* 13px to rem */
  color: #3b3b3b;
  font-family: Medium;
}
.middle1-head {
  font-family: Roboto;
  font-size: 18px;
  font-size: 1.125rem; /* 18px to rem */
  color: #000;
  margin-bottom: 1.85714rem; /* 26px to rem */
}
.body-item {
  /* font-family: Light; */
  font-weight: 400;
  font-size: 0.875rem; /* 14px to rem */
  color: #212224 !important;
  line-height: 1.21429; /* 17px to rem */
  letter-spacing: 0.07143rem; /* 1px to rem */
  margin-bottom: 0.75rem; /* 12px to rem */
}
.body-item:last-child {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .bottom-body {
    flex-direction: column;
    align-items: center;
    /* padding: 20px; */
    padding-top: 0;
  }

  .middle2,
  .middle1,
  .body-left {
    width: 100%;
    margin-bottom: 30px;
    text-align: center;
  }

  .left-bottom {
    text-align: center;
    font-size: 14px;
  }

  .middle1-head {
    font-size: 16px;
    margin-bottom: 15px;
  }

  .body-item {
    font-size: 14px;
    margin-bottom: 10px;
  }

  #bottom {
    height: auto;
    padding: 20px 0;
  }

  .Home-container {
    width: 100%;
  }
}
</style>
